import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'
import {
  ReadCommissionsRequestDto,
  ReadCommissionsResponseDto,
  ApproveCommissionResponseDto,
  UpdateCommissionRequestDto,
  UpdateCommissionResponseDto,
  ApproveCommissionRequestDto,
  RejectCommissionResponseDto,
  RejectCommissionRequestDto,
} from '@sparling/financial-common'

export const fetchCommissions = async (
  { token, ...params }: ReadCommissionsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadCommissionsResponseDto> => {
  const response = await axios.get<ReadCommissionsResponseDto>(`${process.env.REACT_APP_SERVER_URL}/crm/commissions`, {
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const approveCommissions = async (
  { token, ...data }: { token: string } & ApproveCommissionRequestDto,
  options: AxiosRequestConfig = {},
): Promise<ApproveCommissionResponseDto> => {
  const response = await axios.post<ApproveCommissionResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/commissions/approve`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateCommissions = async (
  { token, ...data }: { token: string } & UpdateCommissionRequestDto,
  options: AxiosRequestConfig = {},
): Promise<UpdateCommissionResponseDto> => {
  const response = await axios.post<UpdateCommissionResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/commissions/update`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const rejectCommissions = async (
  { token, ...data }: { token: string } & RejectCommissionRequestDto,
  options: AxiosRequestConfig = {},
): Promise<RejectCommissionResponseDto> => {
  const response = await axios.post<RejectCommissionResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/commissions/reject`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
